<template>
    <NewHomeCard :card-type="cardType" :background-style="backgroundStyle">
        <template #title>
            <div class="title-body flex justify-between items-center text-white">
                Keep the momentum going
                <span class="h-10 min-w-10 flex items-center justify-center">
                    <span class="body-small text-white/80">{{ actionItems.length }} topics</span>
                </span>
            </div>
        </template>
        <template #content>
            <div class="space-y-2">
                <a
                    v-for="item in actionItems"
                    :key="item.hashid"
                    :href="`/coach/start/?wrapped_action_item=${item.hashid}&chat_source=home_wrapped`"
                    class="body text-left py-2.5 px-5 rounded-2xl transition-all flex gap-2 fs-mask bg-white/15 hover:bg-white/20"
                    @click="handleActionItemClick(item)">
                    <i class="bi bi-arrow-right text-white/80 mt-0.5" aria-hidden="true"></i>
                    <div class="flex-1 min-w-0">
                        <span v-if="item.label" class="inline-block details text-white bg-white/20 px-2 py-0.5 rounded mb-1">{{ item.label }}</span>
                        <p class="mb-0 line-clamp-2 text-white">{{ item.topic }}</p>
                        <p class="details text-white/70 mt-0.5 line-clamp-1">Building on {{ item.strength }}</p>
                    </div>
                </a>
            </div>
        </template>
    </NewHomeCard>
</template>

<script setup>
import AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logUserInteraction } from "~vue/utils/logUtils";
import { onMounted } from "vue";

import NewHomeCard from "./NewHomeCard.vue";

const { actionItems, cardType } = defineProps({
    actionItems: { type: Array, required: true },
    cardType: { type: String, required: true },
});

onMounted(() => logUserInteraction(AmplitudeEventNames.WRAPPED_ACTION_ITEMS_SHOWN, { topics: actionItems.map((item) => item.topic) }));

const backgroundStyle = {
    background: "linear-gradient(to right, #ac93c2, #7065cb 30%, #a68acb)",
};

const handleActionItemClick = (item) => {
    logUserInteraction(AmplitudeEventNames.HOMEPAGE_WRAPPED_ACTION_ITEM_CLICKED, { topic: item.topic, hashid: item.hashid, source: "momentum_card" });
};
</script>
